<template>
  <div id="view-main">
    <!-- Core page content -->
    <div>
      <div id="main-section-a" class="content-section"><SectionHero /></div>
      <div id="main-section-general" class="content-section">
        <div>
          <div class="sub-section">
            <div class="text-bubble">
              <h2>
                Hi, we're Erica and Lindsey and we'll be helping you learn how
                to fly!
              </h2>
            </div>
            <div id="erica-and-lindsey-section">
              <img src="@/assets/images/kid-main-a.png" />
              <img src="@/assets/images/kid-main-b.png" />
            </div>
          </div>
          <div
            class="sub-section"
            :class="{ active: subSection1 }"
            v-scroll-into-view="{
              threshold: 0.8,
              cb: () => displaySubsection('subSection1')
            }"
          >
            <div class="section-header">
              <SectionTitleCard
                text="Learn the Basics!"
                :active="subSection1"
                reversed
              />
            </div>
            <div class="section-content">
              <div class="section-image">
                <div class="image-frame">
                  <img src="@/assets/images/screenshot-1.png" />
                </div>
              </div>
              <div class="section-text">
                <div class="text-box">
                  <p>
                    Learn how a drone operates and the basics of taking off,
                    maneuvering, and landing safely. Progress your skills with
                    more advanced modules and ultimately tackle the Drone Racing
                    Course!
                  </p>
                  <AppButton @click="$root.openShop">Available Now!</AppButton>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div
            class="sub-section"
            :class="{ active: subSection2 }"
            v-scroll-into-view="{
              threshold: 0.8,
              cb: () => displaySubsection('subSection2')
            }"
          >
            <div class="section-header">
              <SectionTitleCard
                text="Drone Racing Course!"
                :active="subSection2"
                color-a="#00ccff"
                color-b="#0e89ff"
                color-c="#4580c2"
                color-d="#0e56ff"
              />
            </div>
            <div class="section-content">
              <div class="section-text">
                <div class="text-box">
                  <p>
                    Practice your skills on a Drone Race Course that was modeled
                    after an actual course! This is for advanced operators and
                    perfect to practicing and testing your skills!
                  </p>
                  <AppButton @click="$root.openShop">Available Now!</AppButton>
                </div>
              </div>
              <div class="section-image">
                <div class="image-frame">
                  <img src="@/assets/images/screenshot-2.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="main-section-lwp" class="content-section reg">
        <div>
          <div>
            <h2>Learn While Playing!</h2>
            <p>
              Master three fun games designed to help practice specific areas
              crucial to drone flight.
            </p>
          </div>
          <div>
            <div>
              <div class="image-frame">
                <img src="@/assets/images/screenshot-3.png" />
              </div>
              <h3>Maze</h3>
              <p>Practice flying your drone through a complex maze!</p>
            </div>
            <div>
              <div class="image-frame">
                <img src="@/assets/images/screenshot-4.png" />
              </div>
              <h3>Pass Through the Wall</h3>
              <p>
                Maneuver your drone through the holes in the walls to score
                points. Don't hit the walls or go too far outside the course or
                you will lose a life! Lose three lives and it's game over!
              </p>
            </div>
            <div>
              <div class="image-frame">
                <img src="@/assets/images/screenshot-5.png" />
              </div>
              <h3>Ball Collector</h3>
              <p>
                Collect all of the spheres in the level to win! But be careful,
                touching the big green drone or crashing will make you lose a
                life! Lose three lives and it’s game over!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="main-section-parents" class="content-section">
        <div>
          <div
            class="sub-section"
            :class="{ active: subSection3 }"
            v-scroll-into-view="{
              threshold: 0.4,
              cb: () => displaySubsection('subSection3')
            }"
          >
            <div class="sub-section-header">
              <SectionTitleCard
                text="Safety first!"
                :active="subSection3"
                color-a="#d7489a"
                color-b="#9f2487"
                color-c="#9f2487"
                color-d="#6c008d"
                reversed
              />
            </div>
            <div class="sub-section-content">
              <div class="sub-section-item sub-section-image">
                <img src="@/assets/images/kid-3.png" />
              </div>
              <div class="sub-section-item sub-section-text">
                <div class="text-box">
                  <p>
                    Understanding drone safety guidelines is paramount before
                    taking off. In addition to FAA guidelines, make sure you
                    understand your local laws and regulations. With Kids with
                    Drones (powered by Zephyr), you will learn about drone
                    safety and how to start a drone, take off, perform various
                    maneuvers, and finally land the drone!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div
            class="sub-section"
            :class="{ active: subSection4 }"
            v-scroll-into-view="{
              threshold: 0.4,
              cb: () => displaySubsection('subSection4')
            }"
          >
            <div class="sub-section-header">
              <SectionTitleCard
                text="Risk-Free Environment"
                :active="subSection4"
                color-a="#f1de00"
                color-b="#ff930e"
                color-c="#ff930e"
                color-d="#ff5447"
              />
            </div>
            <div class="sub-section-content reverse">
              <div class="sub-section-item sub-section-text">
                <div class="text-box">
                  <p>
                    Practice your skills on a Drone Race Course that was modeled
                    after an actual course! This is for advanced operators and
                    perfect to practicing and testing your skills!
                  </p>
                </div>
              </div>
              <div class="sub-section-item sub-section-image">
                <img src="@/assets/images/kid-6.png" />
              </div>
            </div>
          </div>
          <!--  -->
          <div
            class="sub-section"
            :class="{ active: subSection5 }"
            v-scroll-into-view="{
              threshold: 0.4,
              cb: () => displaySubsection('subSection5')
            }"
          >
            <div class="sub-section-header">
              <SectionTitleCard
                text="So many ways to use drones!"
                :active="subSection5"
                color-a="#d4e200"
                color-b="#4ce6b4"
                color-c="#a0cc3a"
                color-d="#34a8a4"
                reversed
              />
            </div>
            <div class="sub-section-content">
              <div class="sub-section-item sub-section-image">
                <img src="@/assets/images/kid-5.png" />
              </div>
              <div class="sub-section-item sub-section-text">
                <div class="text-box">
                  <p>
                    Drones are a great way to get kids excited about STEM and
                    the lessons learned lead to broader job opportunities and
                    actionable skills for the future. There are countless ways
                    to use drones! From art to engineering, drones offer us an
                    exciting world of opportunities to learn, play, and enrich
                    our lives.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="main-section-get-now" class="content-section reg">
        <div>
          <div>
            <h2><span>Get Kids with Drones Today!</span></h2>
          </div>
          <div>
            <div><img src="@/assets/images/logo-full-backdrop.png" /></div>
            <div>
              <div>
                <p>
                  Learning how to fly drones has never been easier! Kids with
                  Drones provides your child an important and inexpensive first
                  step into STEM fields and other valuable real-world
                  applications. Give your kid a jumpstart with the skills
                  they’ll need to be successful hidden within a game-like
                  experience that they will love!
                </p>
                <AppButton @click="$root.openShop">Get it now!</AppButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

import SectionHero from '@/components/SectionHero';

@Component({
  components: {
    SectionHero
  }
})
class Main extends Vue {
  subSection1 = false;
  subSection2 = false;
  subSection3 = false;
  subSection4 = false;
  subSection5 = false;

  displaySubsection(key) {
    this[key] = true;
  }
}

export default Main;
</script>

<style lang="scss" scoped>
@import 'vars';

.sub-section.temp {
  text-align: center;

  .text-box {
    max-width: 500px;
    margin: 100px auto 0;
    text-align: left;
    padding: 30px 0;

    img {
      float: left;
      width: 150px;
      margin: 40px;
      // shape-outside: margin-box;
      shape-outside: url('~@/assets/images/kid-3.png');
      shape-margin: 40px;
    }
  }
}

.sub-section {
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  margin: 0 auto;
  padding: 120px 40px;

  @include mobile-mode {
    padding: 80px 40px;
  }

  // img {
  //   opacity: 0;
  //   transform: scale(0.25);
  //   transition: 0.5s cubic-bezier(0.01, 0.85, 0.42, 1.73);
  // }

  .text-box {
    opacity: 0;
    transform: translateY(80px);
    transition: 1s;

    @include mobile-mode {
      text-align: center;
    }
  }

  .section-title-card {
    opacity: 0;
    transform: rotateZ(-10deg);
    transition: 0.25s;
  }

  > h2 {
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
    color: #0e89ff;
    font-size: 60px;
  }

  > .section-header {
    margin: 0 0 100px 0;
    text-align: center;
  }

  &.active {
    .section-title-card {
      transform: rotateZ(0);
      opacity: 1;
    }

    img {
      transform: scale(1);
      opacity: 1;
    }

    .text-box {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

#view-main {
  display: inline-block;
  position: relative;
  margin: 0;
  overflow: auto;
  animation: main 1s both;
  flex-grow: 1;

  .image-frame {
    display: inline-block;

    @include screen-small {
      transform: rotateZ(0) !important;
    }

    > img {
      // max-width: 500px;
      max-width: 100%;
      // width: 100%;
      border: 5px solid white;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 50px 50px -40px rgba(0, 0, 0, 0.25),
        0 0 60px 0 rgba(0, 0, 0, 0.1);
    }
  }

  > div {
    position: relative;
    z-index: 1;
  }
}

// #main-section-a {
// }

@keyframes sectionTitle {
  0% {
    transform: rotateZ(-10deg);
    opacity: 0;
  }

  100% {
    transform: rotateZ(0);
    opacity: 1;
  }
}

#erica-and-lindsey-section {
  text-align: center;

  img {
    padding: 0 20px;
    width: 250px;
    max-width: 40%;
    filter: drop-shadow(0 8px 5px rgba(0, 0, 0, 0.55));
    box-sizing: border-box;

    @include screen-small {
      margin: 10px;
    }
  }
}

.text-bubble {
  background: #0e89ff;
  // background: linear-gradient(#00b8ff, #1d77ff);
  // background: linear-gradient(#00b8ff, #7f36f3);
  background: linear-gradient(#5fccf7, #b299ff);
  padding: 80px;
  border-radius: 100%;
  text-align: center;
  color: white;
  max-width: 600px;
  margin: 0 auto 60px;
  position: relative;
  // filter: drop-shadow(0 8px 15px rgba(0, 0, 0, 0.55));
  filter: drop-shadow(0px 36px 34px rgba(133.3, 130.4, 255, 0.35));

  @include screen-small {
    padding: 30px;
  }

  h2 {
    font-size: 50px;

    @include screen-small {
      font-size: 30px;
    }
  }

  &:before {
    content: '';
    position: absolute;
    bottom: -25px;
    right: 35%;
    width: 0;
    height: 0;
    border: 60px solid transparent;
    border-top-color: #b299ff;
    border-bottom: 0;
    border-right: 0;
    margin-left: -10px;
    margin-bottom: -20px;
    transform: rotateZ(-15deg);
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -25px;
    left: 35%;
    width: 0;
    height: 0;
    border: 60px solid transparent;
    border-top-color: #b299ff;
    border-bottom: 0;
    border-left: 0;
    margin-left: -10px;
    margin-bottom: -20px;
    transform: rotateZ(15deg);
  }
}

#main-section-general {
  color: #545454;
  background-image: url(~@/assets/images/test-2.png);

  > div {
    display: flex;
    flex-direction: column;
    padding: 40px 0;
    position: relative;
    z-index: 2;

    > h2 {
      text-align: center;
      max-width: 800px;
      margin: 80px auto;
      color: #0e89ff;
      font-size: 60px;
    }

    > .sub-section {
      display: flex;
      flex-direction: column;
      max-width: 1000px;
      margin: 0 auto;
      padding: 120px 40px;

      > .section-header {
        margin: 0 0 100px 0;
        text-align: center;
      }

      > .section-content {
        display: flex;

        @include mobile-mode {
          flex-direction: column;
          align-items: center;
        }

        > .section-image {
          flex-grow: 1;
          max-width: 500px;

          @include mobile-mode {
            margin: 0 0 40px !important;
          }
        }

        > .section-text {
          flex-basis: 50%;

          @include mobile-mode {
            margin: 0 !important;
          }
        }
      }

      @include mobile-mode {
        padding: 80px 40px;
      }

      .section-title-card {
        opacity: 0;
        transform: rotateZ(-10deg);
        transition: 0.25s;
      }

      .image-frame {
        img {
          opacity: 0;
          transform: scale(0.25);
          transition: 0.5s cubic-bezier(0.01, 0.85, 0.42, 1.73);

          @include mobile-mode {
            width: 100%;
          }
        }
      }

      .text-box {
        opacity: 0;
        transform: translateY(80px);
        transition: 1s;

        @include mobile-mode {
          text-align: center;
        }
      }

      &:nth-child(2) {
        > .section-content {
          > .section-image {
            margin-right: 80px;
          }
        }

        .image-frame {
          transform: rotateZ(-5deg);
        }
      }

      &:nth-child(3) {
        > .section-content {
          @include mobile-mode {
            flex-direction: column-reverse;
          }

          > .section-text {
            margin-right: 80px;
          }
        }

        .image-frame {
          transform: rotateZ(5deg);
        }
      }

      &.active {
        .section-title-card {
          transform: rotateZ(0);
          opacity: 1;
        }

        img {
          // transform: rotateZ(0);
          transform: scale(1);
          opacity: 1;
        }

        .text-box {
          opacity: 1;
          transform: translateY(0);
        }
      }
    }
  }
}

#main-section-lwp {
  background: linear-gradient(#00d0da, #00ca88);
  clip-path: polygon(0 5%, 100% 0, 100% 100%, 0% 95%);
  margin-top: -60px;
  margin-bottom: -60px;
  z-index: 2;

  > div {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 120px 20px 120px;

    > div:nth-child(1) {
      margin: 0 0 80px 0;
      text-align: center;

      h2 {
        margin: 0;
      }
    }

    > div:nth-child(2) {
      display: flex;
      justify-content: center;
      max-width: 1400px;
      margin: 0 auto;

      @include mobile-mode {
        flex-direction: column;
      }

      > div {
        // flex: 0 0 1;
        flex-basis: calc(100% / 3);
        text-align: center;
        padding: 0 20px;

        img {
          width: 350px;
        }
      }
    }
  }

  &::after {
    background: url(~@/assets/images/section-background-3.png);
  }
}

#main-section-parents {
  color: #545454;
  background-image: url(~@/assets/images/test-2.png);

  h2 {
    margin: 0;
    // color: #404040;
    color: white;
    position: relative;
    display: inline-block;

    > span {
      text-shadow: -5px 6px 0px rgba(0, 0, 0, 0.15);
      position: relative;
      z-index: 1;
    }

    &::before {
      content: '';
      position: absolute;
      top: -30px;
      right: -50px;
      left: -50px;
      bottom: -30px;
      margin: 0 auto;
      // border-radius: 100%;
      background: linear-gradient(#f35d5d, #e64c9b);
      clip-path: polygon(0 25%, 100% 0, 100% 100%, 0% 75%);
      z-index: 0;
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    // margin: 0 auto;
    // padding: 120px 20px 120px;
    padding: 40px 0;
    position: relative;
    z-index: 2;

    > div {
      // display: flex;
      // flex-direction: column;
      // max-width: 800px;
      // margin: 0 auto;
      // padding: 80px 20px;

      // &:nth-child(1) {
      //   img {
      //     width: 150px;
      //   }
      //
      //   > div:nth-child(1) {
      //     margin: 0 0 80px 0;
      //     text-align: center;
      //
      //     h2 {
      //       margin: 0;
      //     }
      //   }
      //
      //   > div:nth-child(2) {
      //     display: flex;
      //
      //     @include screen-small {
      //       flex-direction: column;
      //     }
      //
      //     > div:nth-child(1) {
      //       margin-right: 80px;
      //
      //       @include screen-small {
      //         margin-right: 0;
      //         text-align: center;
      //       }
      //     }
      //
      //     > div:nth-child(2) {
      //       //
      //     }
      //   }
      // }
      //
      // &:nth-child(2) {
      //   max-width: 480px;
      //
      //   img {
      //     width: 150px;
      //   }
      //
      //   > div:nth-child(1) {
      //     margin: 0 0 80px 0;
      //     text-align: center;
      //   }
      //
      //   > div:nth-child(2) {
      //     display: flex;
      //
      //     > div:nth-child(1) {
      //       margin-right: 40px;
      //     }
      //
      //     > div:nth-child(2) {
      //       //
      //     }
      //   }
      // }
      //
      // &:nth-child(3) {
      //   img {
      //     width: 150px;
      //   }
      //
      //   > div:nth-child(1) {
      //     margin: 0 0 80px 0;
      //     text-align: center;
      //
      //     h2 {
      //       margin: 0;
      //     }
      //   }
      //
      //   > div:nth-child(2) {
      //     display: flex;
      //
      //     > div:nth-child(1) {
      //       margin-right: 80px;
      //     }
      //
      //     > div:nth-child(2) {
      //       //
      //     }
      //   }
      // }
    }

    .sub-section {
      display: flex;
      flex-direction: column;
      max-width: 800px;
      margin: 0 auto;
      padding: 80px 20px;

      max-width: 480px;

      .sub-section-header {
        margin: 0 0 80px 0;
        text-align: center;

        h2 {
          margin: 0;
        }
      }

      .sub-section-content {
        display: flex;
        font-size: 24px;

        @include screen-small {
          flex-direction: column;
          text-align: center;
        }

        .sub-section-item {
          &.sub-section-text {
            p {
              margin: 0;
            }
          }

          &.sub-section-image {
            img {
              width: 150px;
            }
          }

          &:nth-child(1) {
            margin-right: 40px;

            @include screen-small {
              margin-right: 0;
            }
          }
        }

        &.reverse {
          @include screen-small {
            flex-direction: column-reverse;
          }
        }
      }
    }
  }

  // &::after {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   left: 0;
  //   bottom: 0;
  //   background: url(~@/assets/images/section-background.png);
  //   // opacity: 0.5;
  //   background-repeat: repeat;
  //   z-index: 1;
  // }
}

#main-section-get-now {
  background: linear-gradient(#f35d5d, #e64c9b);
  clip-path: polygon(0 5%, 100% 0, 100% 100%, 0% 100%);
  margin-top: -60px;
  // margin-bottom: -60px;

  > div {
    display: flex;
    flex-direction: column;
    max-width: 1250px;
    margin: 0 auto;
    padding: 80px 20px;
    // padding: 120px 20px 80px;

    > div:nth-child(1) {
      margin: 0 0 30px 0;
      text-align: center;

      h2 {
        margin: 0;
      }
    }

    > div:nth-child(2) {
      display: flex;
      justify-content: center;

      @include mobile-mode {
        flex-direction: column;
      }

      > div {
        // flex: 0 0 1;
        flex-basis: calc(100% / 2.5);
        text-align: center;
        padding: 0 20px;
        // align-items: center;
        // justify-content: center;

        img {
          width: 450px;
          max-width: 100%;

          // @include mobile-mode {
          //   width: 100%;
          // }
        }

        &:nth-child(2) {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  &::after {
    background: url(~@/assets/images/section-background-2.png);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue